import { type Customer } from './types'
import { type APICustomer, APICustomerFromJSON } from '../../../generated-types'
import LogTool from '../../../logger/logTools'
import { apiClient } from '../../../api/client'
import { buildFetchUrl, createContact, getPKfromSelf, parseNestedObjectList } from '../../../utils/functions'

const log = new LogTool({ context: 'customerUtils', enable: true, logLevel: 'warn' })
/* -------------------------------------------------------------------------- */
/*                           Utility functions start                          */
/* -------------------------------------------------------------------------- */

/**
 * Convert an Customer-Server-Response into an CustomerInfo object.
 * @param responseObject The APIArticle response Object.
 * @returns
 */
export function createCustomer(responseObject: any): Customer {
  const c: APICustomer = APICustomerFromJSON(responseObject)

  return {
    ...c,
    key: getPKfromSelf(c.self),
    contacts: parseNestedObjectList(c.contacts, createContact),
  }
}

/* -------------------------------------------------------------------------- */
/*                             API functions start                            */
/* -------------------------------------------------------------------------- */
export async function fetchCustomer(
  url: string,
  onSuccess: (response: Customer) => void,
  onError: (error: any) => void,
  parameter: string[] = []
): Promise<void> {
  log.warn(
    'fetchCustomer is deprecated. Please migrate to useCustomer() from features/Customer/hooks/useCustomerQueries.'
  )
  log.info('Begin fetching supplier.')

  const fetchUrl = url + buildFetchUrl('', parameter)
  try {
    const response = await apiClient.get<any>(fetchUrl)
    log.info('Successfully fetched supplier.')
    const supplier = createCustomer(response)
    onSuccess(supplier)
  } catch (error) {
    log.error('Error fetching supplier.', error)
    onError(error)
  }
}
